module.exports = __webpack_public_path__ + "img/sponsors-logo.39afa2a9.png";